module.exports = __webpack_public_path__ + "static/media/player-of-the-match.svg.6ececbbb.png";